module.exports = __webpack_public_path__ + "img/streamline-icon-office-building@450x450.e1d570e6.svg";